import React from 'react';
import GameQuery from '../../query/GameQuery';
import BusinessPlan from '../../components/BusinessPlan';
import { Route } from 'react-router-dom';
import { BUSINESSPLAN } from '../../routes';

const BusinessPlanRoute = () => 
	<GameQuery>
		{({ game }) => 
			<Route
				path={BUSINESSPLAN}
				render={props => <BusinessPlan {...props} game={game} />}
			/>
		}
	</GameQuery>
;

export default BusinessPlanRoute;
